$('.section-title .title').each(function() {
    let contents = $(this).text();

    $(this).attr('title', contents.replace(/s/g, 'S'));
});